import { render, staticRenderFns } from "./page-detail-header.vue?vue&type=template&id=524edca8&scoped=true"
import script from "./page-detail-header.vue?vue&type=script&lang=js"
export * from "./page-detail-header.vue?vue&type=script&lang=js"
import style0 from "./page-detail-header.vue?vue&type=style&index=0&id=524edca8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "524edca8",
  null
  
)

export default component.exports